import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "tw-inline-flex tw-items-center tw-justify-center tw-whitespace-nowrap tw-rounded-md tw-text-sm tw-font-medium tw-ring-offset-background tw-transition-colors focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-ring focus-visible:tw-ring-offset-2 disabled:tw-pointer-events-none disabled:tw-opacity-50",
  {
    variants: {
      variant: {
        default:
          "tw-bg-purple-300 tw-text-white tw-shadow hover:tw-bg-purple-500",
        secondary:
          "tw-border tw-border-purple-200 tw-bg-purple-200 tw-text-white",
        "secondary-outlined":
          "tw-border tw-border-purple-300 tw-bg-white tw-text-purple-300 hover:tw-border-purple-200 hover:tw-bg-purple-200 hover:tw-text-white",
        ghost: "",
        link: "tw-text-primary tw-underline-offset-4 hover:tw-underline",
        outline: "tw-border tw-border-primary tw-text-primary",
        danger: "tw-bg-red-500 tw-text-white hover:tw-bg-red-700",
      },
      size: {
        default: "tw-h-9 tw-px-4 tw-py-2",
        sm: "tw-h-8 tw-rounded-md tw-px-3 tw-text-xs",
        lg: "tw-rounded-md tw-px-8 tw-py-3 tw-font-bold",
        icon: "tw-h-9 tw-w-9",
        plain: "",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
